import Index from '@tunnel-components/@pages/resetPassword/container'

/**
 * @export Container
 */

export default Index



// WEBPACK FOOTER //
// ./src/apps/tunnel/components/@pages/resetPassword/index.ts